import { ComponentClassNames } from '../../util/classNames';
import { Depth, getDepthBoxShadow } from '../../util/styles/depth';
import { ZIndex } from '../../util/styles/zIndex';
import { memoizeFunction, mergeStyleSets } from '../../util/styling';

import { defaultFooterHeight } from './PageLayout.styles';

type FooterClassNames = ComponentClassNames<'footer'>;

export const getClassNames = memoizeFunction((): FooterClassNames => {
  const footerBoxShadow = getDepthBoxShadow(Depth.depth16);

  return mergeStyleSets({
    footer: {
      height: defaultFooterHeight,
      position: 'fixed',
      bottom: 0,
      right: 0,
      left: 0,
      zIndex: ZIndex.PageLayoutFooter,
      boxShadow: footerBoxShadow,
    },
  });
});
